var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.category && _vm.category.store)?_c('div',{staticClass:"booker-awards-container"},[_c('CategoryTitle',{attrs:{"category":_vm.category}}),_c('AwardstListGrid',{attrs:{"category":_vm.category}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }